import { useQuery } from '@tanstack/react-query';
import { AutocompleteElement, useFormContext } from 'react-hook-form-mui';

import Api from '@barboxx/api';
import { ProductCategory } from '@barboxx/models/types';

interface Props {
    disabled?: boolean;
}

interface ProductCategoryWatchProps {
    productCategory?: ProductCategory;
}

export function ProductCategoryInput({ disabled = false }: Props) {
    const { productCategory } =
        useFormContext<ProductCategoryWatchProps>().getValues();
    const productCategoryQueryResult = useQuery({
        queryKey: ['productCategories'],
        queryFn: () =>
            Api.Products.Categories.getProductCategories({
                page: 0,
                size: 1000,
                sort: 'name,asc',
            }),
        initialData: {
            ok: true,
            problem: null,
            originalError: null,
            data: {
                results: productCategory ? [productCategory] : [],
                total: 1,
                isPaginated: false,
            },
        },
    });

    return (
        <AutocompleteElement
            label="Alcohol Category"
            name="productCategoryId"
            loading={productCategoryQueryResult.isLoading}
            multiple={false}
            options={productCategoryQueryResult.data?.data?.results ?? []}
            transform={{
                output(event, value, reason, details) {
                    if (reason === 'selectOption') {
                        return typeof value === 'string' ? value : value?.id;
                    }
                    if (reason === 'removeOption') {
                        return null;
                    }
                    return value;
                },
            }}
            autocompleteProps={{
                fullWidth: true,
                readOnly: disabled,
                disabled: disabled,
                isOptionEqualToValue(
                    option?: ProductCategory,
                    value?: ProductCategory | number | null
                ) {
                    const isNumber = typeof value === 'number';

                    if (isNumber) {
                        return option?.id === value;
                    } else {
                        return option?.id === (value?.id ?? value);
                    }
                },
                getOptionLabel(option) {
                    if (typeof option === 'string') {
                        return option;
                    }
                    return `${option?.name}`;
                },
            }}
        />
    );
}
